import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { SuiDropdownOption } from '@splashthat/sui';

import { getSocialRsvpFieldPrepopulatedId } from 'common/entities/formNode/selectors';

import { setPrepopulatedNode } from '../../../actions/socialRsvp';
import { getCustomNodes, getFormId } from '../../../selectors';
import { SelectNodeDropdown } from './SelectFormNode.styles';

const NO_QUESTION_VALUE = 'noQuestion';
const NO_QUESTION_TEXT = 'No question set';

const SelectFormNode = (props) => {
    const dispatch = useDispatch();
    const formId = useSelector(getFormId);
    const customNodes = useSelector((state) => getCustomNodes(state, formId));
    const prepopulatedNodeId = useSelector((state) =>
        getSocialRsvpFieldPrepopulatedId(state, formId, props.socialNetworkOption),
    );
    const setPrepoulatedNodeId = useCallback(
        (nodeId) => dispatch(setPrepopulatedNode(props.socialNetworkOption, nodeId)),
        [dispatch],
    );

    return (
        <SelectNodeDropdown
            label={props.label}
            defaultValue={NO_QUESTION_VALUE}
            onChange={(_, nodeId) => setPrepoulatedNodeId(nodeId !== NO_QUESTION_VALUE ? nodeId : null)}
            value={prepopulatedNodeId}
        >
            {customNodes.map((node) => (
                <SuiDropdownOption key={node.id} value={node.id} displayValue={node.label} />
            ))}
            <SuiDropdownOption key={NO_QUESTION_VALUE} value={NO_QUESTION_VALUE} displayValue={NO_QUESTION_TEXT} />
        </SelectNodeDropdown>
    );
};

SelectFormNode.propTypes = {
    label: PropTypes.string.isRequired,
    socialNetworkOption: PropTypes.string.isRequired,
};

SelectFormNode.defaultProps = {};

export default SelectFormNode;
